<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb"><!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Hardware</a></li>
          <li><a>Sensor Types</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home" alt="Home icon"></a>
        </div>
      </div>
      <div class="block">
        <div class="page-header"> <!--changed new-->
          <span class="page-header__title">Sensor Types</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>
        <div class="list_block">
          <div class="toolbar"> <!--search and new changed new-->
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg" alt="Search icon">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by sensor type name, abbreviation"/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let sensortype of sensorTypesList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg" alt="Left arrow icon">
                  <span>{{ sensortype && sensortype.name }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <img src="../../../../../../assets/images/New_Icons/calendar-icon.svg" alt="Calendar icon">
                  <span>Updated At: {{sensortype && sensortype.updatedAt | date: "dd MMM yyyy"}}</span>
                </div>
                <div class="master-card-body-info">
                  <img src="../../../../../../assets/images/New_Icons/descriptio-card-icon.svg" alt="Description icon">
                  <span
                    class="description">{{sensortype && sensortype.description ? sensortype && sensortype.description : 'NA'}}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Abbreviation:</span>
                  <span class="text">{{ sensortype?.abbreviation || "NA" }}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" alt="Edit icon" title="Edit Business Type" (click)="getSensorTypeById(sensortype.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Sensor types Not Found</div>
        <!--sensor types block end-->
      </div>
      <!--add/update form-->
      <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
        <!--outside close-->
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">Sensor Type</div>
                <button class="add-update-submit-button" (click)="addUpdateSensorType()" [disabled]="sensorTypeDoubleClick">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Name</mat-label>
                  <input matInput id="activityName" type="text" formControlName="name" autocomplete="off" placeholder="Enter name"/>
                  <!-- Hint -->
                  <mat-hint><i>3–20 alphabetic characters</i></mat-hint>
                  <!-- Single dynamic error -->
                  <mat-error *ngIf="(f.name.dirty || f.name.touched || submitted) && f.name.errors">
                    <i> {{f.name.hasError('required') ? 'Sensor type name is required.': f.name.hasError('minlength')? 'Minimum 3 characters required.': f.name.hasError('maxlength')
                      ? 'Maximum 20 characters allowed.' : f.name.hasError('pattern') ? 'Only alphabets allowed.': ''}}</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Abbreviation</mat-label>
                  <input matInput id="unitCode" type="text" autocomplete="off" formControlName="abbreviation" placeholder="Enter abbreviation"/>
                  <mat-hint><i>3–10 alphanumeric characters</i></mat-hint>
                  <mat-error *ngIf="(f.abbreviation.touched || f.abbreviation.dirty || submitted) && f.abbreviation.errors">
                    <i>
                      {{ f.abbreviation.hasError('required') ? 'Abbreviation is required.' :
                      f.abbreviation.hasError('maxlength') ? 'Maximum 10 characters allowed.' :
                        f.abbreviation.hasError('pattern') ? 'Only alphanumeric characters allowed.' : ''
                      }}
                    </i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Description</mat-label>
                  <textarea matInput id="activityDescription" rows="3" formControlName="description" autocomplete="off" placeholder="Description"></textarea>
                  <mat-hint><i>Up to 200 characters</i></mat-hint>
                  <mat-error *ngIf="(f.description.dirty || f.description.touched || submitted) && f.description.hasError('maxlength')">
                    <i>Maximum 200 characters allowed.</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--add/update form end-->
    </div>
  </div>
</div>
